import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const PflasterDach = () => {
  const pageData = {
    title: 'REINIGUNG',
    subtitle: 'Pflaster & Dach',
    description: 'Professionelle Reinigung von Pflasterflächen und Dächern. Werterhaltung durch regelmäßige Pflege.',
    heroImage: 'https://images.unsplash.com/photo-1775416918087-b61a8501d743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxyb29mJTIwY2xlYW5pbmclMjBwcmVzc3VyZSUyMHdhc2hlciUyMHRpbGVzJTIwbW9zcyUyMHJlbW92YWx8ZW58MHx8fHwxNzc3NjI5OTM1fDA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Pflasterreinigung', description: 'Hochdruckreinigung von Pflastersteinen und Terrassen.' },
      { title: 'Dachreinigung', description: 'Entfernung von Moos, Algen und Verschmutzungen.' },
      { title: 'Fassadenreinigung', description: 'Schonende Reinigung verschmutzter Fassaden.' },
      { title: 'Imprägnierung', description: 'Schutzbehandlung nach der Reinigung.' },
      { title: 'Fugensanierung', description: 'Erneuerung beschädigter Fugen.' },
      { title: 'Regelmäßige Wartung', description: 'Wartungsverträge für langfristigen Schutz.' }
    ],
    benefits: [
      'Werterhalt der Immobilie',
      'Verbessertes Erscheinungsbild',
      'Verlängerte Lebensdauer',
      'Entfernung von Rutschgefahr',
      'Umweltschonende Verfahren',
      'Professionelle Ausrüstung'
    ],
    process: [
      { title: 'Besichtigung', description: 'Zustandsprüfung und Angebotsstellung.' },
      { title: 'Vorbereitung', description: 'Schutz angrenzender Bereiche.' },
      { title: 'Reinigung', description: 'Professionelle Reinigung mit Hochdrucktechnik.' },
      { title: 'Nachbehandlung', description: 'Imprägnierung und Schutzanstrich.' }
    ],
    metaKeywords: 'Pflasterreinigung Graubünden, Dachreinigung Cazis, Hochdruckreinigung Schweiz'
  };

  return <ServiceTemplate {...pageData} />;
};

export default PflasterDach;